import React from 'react'
import { withTranslation } from 'react-i18next'

const CookiePolicy = ({ t }) => (
    <div className="policy-page">
        <h1>{t('_pages._cookie_policy.title')}</h1>
        <h3>{t('_pages._cookie_policy.last_updated')}</h3>
        <br />
        <br />
        <br />
        <p>
            {t('_pages._cookie_policy.text_1')} <a href="www.interacty.me">www.interacty.me</a>{' '}
            {t('_pages._cookie_policy.text_2')}
        </p>
        <br />
        <br />
        <h2>Cookies definition</h2>
        <p>{t('_pages._cookie_policy.text_3')}</p>
        <br />
        <br />
        <h2>{t('_pages._cookie_policy.how_uses_cookies')}</h2>
        <p>{t('_pages._cookie_policy.text_4')}</p>
        <br />
        <br />
        <h2>{t('_pages._cookie_policy.third_party_cookies')}</h2>
        <p>{t('_pages._cookie_policy.text_5')}</p>
        <br />
        <br />
        <h2>{t('_pages._cookie_policy.user_choices')}</h2>
        <p>{t('_pages._cookie_policy.text_6')}</p>
        <br />
        <br />
        <p>{t('_pages._cookie_policy.text_7')}</p>
        <br />
        <br />
        <h2>{t('_pages._cookie_policy.policy_changes')}</h2>
        <p>{t('_pages._cookie_policy.text_8')}</p>
        <br />
        <br />
        <h2>{t('_pages._cookie_policy.contact_us')}</h2>
        <p>
            {t('_pages._cookie_policy.text_9')} <a href="mailto:support@interacty.me">support@interacty.me</a>
        </p>
        <br />
        <br />
    </div>
)

export default withTranslation('translations')(CookiePolicy)
